// import { useEffect, useRef, useState } from "react";
// import { CallAPI } from "../utils/apiActions";
// import { silentRevalidate } from "../utils/revalidate";
// import {
//   invalidateByEndpoint,
//   buildCacheKey,
//   deleteCache,
//   getCache,
//   isFresh,
// } from "../utils/apiCache";

// // export function useCallAPI({
// //   end_point,
// //   method = "GET",
// //   apiUrl,
// //   body = "",
// //   isFile,
// //   showDefaultError = true,
// //   ttl = 30_000,
// //   enabled = method === "GET",
// // }) {
// //   const token = localStorage.getItem("accessToken");
// //   const cacheKey = buildCacheKey({ end_point, apiUrl, token, method, body });

// //   const [data, setData] = useState(null);
// //   const [loading, setLoading] = useState(enabled);
// //   const [error, setError] = useState(null);

// //   const mounted = useRef(true);
// //   const baseArgs = [end_point, method, apiUrl, body, isFile, showDefaultError];

// //   // Track component mount/unmount
// //   useEffect(() => () => (mounted.current = false), []);

// //   // ======================
// //   // Auto-fetch GET
// //   // ======================
// //   useEffect(() => {
// //     if (!enabled) return;

// //     if (method === "GET") {
// //       const cached = getCache(cacheKey);

// //       if (cached) {
// //         // Show cached data immediately (even if stale)
// //         setData(cached.data);
// //         setLoading(true); // indicate background refresh
// //       }

// //       // Always revalidate silently
// //       silentRevalidate({ cacheKey, callArgs: baseArgs, ttl })
// //         .then((res) => {
// //           if (!mounted.current) return;
// //           res?.status ? setData(res) : setError(res);
// //         })
// //         .finally(() => mounted.current && setLoading(false));
// //     }
// //   }, [cacheKey, enabled]);

// //   // ======================
// //   // Public API
// //   // ======================
// //   return {
// //     data,
// //     loading,
// //     error,

// //     /**
// //      * GET → silent revalidate
// //      * MUTATIONS → execute and invalidate cache
// //      */
// //     revalidate: (overrideBody, api_url = null) => {
// //       const finalArgs = [
// //         end_point,
// //         method,
// //         api_url ?? apiUrl,
// //         overrideBody ?? body,
// //         isFile,
// //         showDefaultError,
// //       ];

// //       setLoading(true);

// //       if (method === "GET") {
// //         return silentRevalidate({ cacheKey, callArgs: finalArgs, ttl })
// //           .then((res) => {
// //             if (!mounted.current) return res;
// //             res?.status && setData(res);
// //             return res;
// //           })
// //           .finally(() => mounted.current && setLoading(false));
// //       }

// //       // MUTATIONS: POST, PUT, PATCH, DELETE
// //       return CallAPI(...finalArgs)
// //         .then((res) => {
// //           if (!mounted.current) return res;

// //           if (res?.status) {
// //             setData(res);
// //             // Invalidate all cached GETs under same endpoint
// //             invalidateByEndpoint(end_point);
// //           } else {
// //             setError(res);
// //           }
// //           return res;
// //         })
// //         .finally(() => mounted.current && setLoading(false));
// //     },

// //     // Manually invalidate this cache key
// //     invalidate: () => deleteCache(cacheKey),
// //   };
// // }

// export function useCallAPI({
//   end_point,
//   method = "GET",
//   apiUrl,
//   body = "",
//   isFile,
//   showDefaultError = true,
//   ttl = 30_000,
//   enabled = method === "GET",
//   cacheMutations = true, // NEW: allow caching for POST/PATCH/PUT if desired
// }) {
//   const token = localStorage.getItem("accessToken");
//   const cacheKey = buildCacheKey({ end_point, apiUrl, token, method, body });

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(enabled);
//   const [error, setError] = useState(null);

//   const mounted = useRef(true);
//   const baseArgs = [end_point, method, apiUrl, body, isFile, showDefaultError];

//   useEffect(() => () => (mounted.current = false), []);

//   // ======================
//   // Auto-fetch GET
//   // ======================
//   useEffect(() => {
//     if (!enabled) return;

//     if (method === "GET") {
//       const cached = getCache(cacheKey);

//       if (cached) {
//         setData(cached.data);
//         setLoading(true);
//       }

//       silentRevalidate({ cacheKey, callArgs: baseArgs, ttl })
//         .then((res) => {
//           if (!mounted.current) return;
//           res?.status ? setData(res) : setError(res);
//         })
//         .finally(() => mounted.current && setLoading(false));
//     }
//   }, [cacheKey, enabled]);

//   // ======================
//   // Public API
//   // ======================
//   return {
//     data,
//     loading,
//     error,

//     revalidate: (overrideBody, api_url = null) => {
//       const finalArgs = [
//         end_point,
//         method,
//         api_url ?? apiUrl,
//         overrideBody ?? body,
//         isFile,
//         showDefaultError,
//       ];

//       setLoading(true);

//       if (method === "GET") {
//         return silentRevalidate({ cacheKey, callArgs: finalArgs, ttl })
//           .then((res) => {
//             if (!mounted.current) return res;
//             res?.status && setData(res);
//             return res;
//           })
//           .finally(() => mounted.current && setLoading(false));
//       }

//       // MUTATIONS: POST, PUT, PATCH, DELETE
//       return CallAPI(...finalArgs)
//         .then((res) => {
//           if (!mounted.current) return res;

//           if (res?.status) {
//             setData(res);

//             if (cacheMutations) {
//               // Store mutation response in cache
//               const expiresAt = Date.now() + ttl;
//               const cachedEntry = { data: res, expiresAt };
//               localStorage.setItem(cacheKey, JSON.stringify(cachedEntry));
//             } else {
//               // Default: invalidate GET caches
//               invalidateByEndpoint(end_point);
//             }
//           } else {
//             setError(res);
//           }
//           return res;
//         })
//         .finally(() => mounted.current && setLoading(false));
//     },

//     invalidate: () => deleteCache(cacheKey),
//   };
// }

// import { useEffect, useRef, useState } from "react";

// import { silentRevalidate } from "../utils/revalidate";
// import {
//   invalidateByEndpoint,
//   buildCacheKey,
//   deleteCache,
//   getCache,
// } from "../utils/apiCache";
// import { CallAPI } from "../utils/apiActions";

// export function useCallAPI({
//   end_point,
//   method = "GET",
//   apiUrl,
//   body = "",
//   isFile,
//   showDefaultError = true,
//   ttl = 30_000,
//   enabled = true,
// }) {
//   const token = localStorage.getItem("accessToken");
//   const METHOD = method.toUpperCase();
//   const isCacheable = ["GET", "POST", "PUT"].includes(METHOD);

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [refetch, setRefetch] = useState(false);
//   const [error, setError] = useState(null);

//   const mounted = useRef(true);

//   useEffect(() => () => (mounted.current = false), []);

//   const cacheKey = buildCacheKey({
//     end_point,
//     apiUrl,
//     token,
//     method: METHOD,
//     body,
//   });

//   // ======================
//   // AUTO FETCH (cacheable only)
//   // ======================
//   useEffect(() => {
//     if (!enabled || !isCacheable) return;

//     const baseArgs = [
//       end_point,
//       METHOD,
//       apiUrl,
//       body,
//       isFile,
//       showDefaultError,
//     ];

//     const cached = getCache(cacheKey);
//     if (cached) {
//       setData(cached.data); // serve stale
//     } else {
//       setLoading(true);
//     }

//     setRefetch(true);
//     silentRevalidate({ cacheKey, callArgs: baseArgs, ttl })
//       .then((res) => {
//         if (!mounted.current) return;
//         res?.status ? setData(res) : setError(res);
//       })
//       .finally(() => {
//         if (!mounted.current) return;
//         setLoading(false);
//         setRefetch(false);
//       });
//   }, [cacheKey, enabled, isCacheable]);

//   // ======================
//   // MANUAL REVALIDATE
//   // ======================
//   const revalidate = (overrideBody, api_url = null) => {
//     const finalBody = overrideBody ?? body;
//     const finalUrl = api_url ?? apiUrl;

//     const finalArgs = [
//       end_point,
//       METHOD,
//       finalUrl,
//       finalBody,
//       isFile,
//       showDefaultError,
//     ];

//     // ✅ CACHEABLE METHODS → SWR
//     if (isCacheable) {
//       const finalCacheKey = buildCacheKey({
//         end_point,
//         apiUrl: finalUrl,
//         token,
//         method: METHOD,
//         body: finalBody,
//       });

//       const cached = getCache(finalCacheKey);
//       if (cached) {
//         setData(cached.data);
//         setRefetch(true);
//       } else {
//         setLoading(true);
//       }

//       return silentRevalidate({
//         cacheKey: finalCacheKey,
//         callArgs: finalArgs,
//         ttl,
//       })
//         .then((res) => {
//           if (!mounted.current) return res;
//           res?.status ? setData(res) : setError(res);
//           return res;
//         })
//         .finally(() => {
//           if (!mounted.current) return;
//           setLoading(false);
//           setRefetch(false);
//         });
//     }
//     setLoading(true);
//     // ❌ PATCH / DELETE → NO CACHE
//     return CallAPI(...finalArgs)
//       .then((res) => {
//         if (!mounted.current) return res;

//         if (res?.status) {
//           setData(res);
//           invalidateByEndpoint(end_point); // important
//         } else {
//           setError(res);
//         }
//         return res;
//       })
//       .finally(() => mounted.current && setLoading(false));
//   };

//   return {
//     data,
//     loading,
//     error,
//     revalidate,
//     invalidate: () => deleteCache(cacheKey),
//     refetch,
//   };
// }

// import { useEffect, useMemo, useRef, useState } from "react";

// import { silentRevalidate } from "../utils/revalidate";
// import {
//   invalidateByEndpoint,
//   buildCacheKey,
//   deleteCache,
//   getCache,
// } from "../utils/apiCache";
// import { CallAPI } from "../utils/apiActions";

// export function useCallAPI({
//   end_point,
//   method = "GET",
//   apiUrl,
//   body = "",
//   isFile,
//   showDefaultError = true,
//   ttl = 30_000,
//   enabled = true,
// }) {
//   const token = localStorage.getItem("accessToken");
//   const METHOD = method.toUpperCase();

//   // ✅  GET AND POST requests are cacheable
//   const isCacheable = METHOD === "GET" || METHOD === "POST";

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false); // no data yet
//   const [refetch, setRefetch] = useState(false); // background refresh
//   const [error, setError] = useState(null);

//   const mounted = useRef(true);
//   useEffect(
//     () => () => {
//       mounted.current = false;
//     },
//     [],
//   );

//   // ======================
//   // CACHE KEY
//   // ======================
//   const cacheKey = useMemo(
//     () =>
//       buildCacheKey({
//         end_point,
//         apiUrl,
//         token,
//         method: METHOD,
//         body,
//       }),
//     [end_point, apiUrl, token, METHOD, body],
//   );

//   // ======================
//   // AUTO FETCH (GET + POST)
//   // ======================
//   useEffect(() => {
//     if (!enabled || !isCacheable) return;

//     const callArgs = [
//       end_point,
//       METHOD,
//       apiUrl,
//       body,
//       isFile,
//       showDefaultError,
//     ];

//     const cached = getCache(cacheKey);
//     if (cached) {
//       setData(cached.data); // serve stale immediately
//     } else {
//       setLoading(true);
//     }

//     setRefetch(true);

//     silentRevalidate({ cacheKey, callArgs, ttl })
//       .then((res) => {
//         if (!mounted.current) return;
//         if (res?.status) {
//           setError(null);
//           setData(res);
//         } else {
//           setError(res);
//         }
//       })
//       .finally(() => {
//         if (!mounted.current) return;
//         setLoading(false);
//         setRefetch(false);
//       });
//   }, [cacheKey, enabled, isCacheable]);

//   // ======================
//   // MANUAL REVALIDATE (GET + POST cacheable, others direct)
//   // ======================
//   const revalidate = (overrideBody, overrideUrl = null) => {
//     const finalBody = overrideBody ?? body;
//     const finalUrl = overrideUrl ?? apiUrl;

//     const callArgs = [
//       end_point,
//       METHOD,
//       finalUrl,
//       finalBody,
//       isFile,
//       showDefaultError,
//     ];

//     // GET → SWR path
//     if (METHOD === "GET" || METHOD === "POST") {
//       const finalCacheKey = buildCacheKey({
//         end_point,
//         apiUrl: finalUrl,
//         token,
//         method: METHOD,
//         body: finalBody,
//       });

//       const cached = getCache(finalCacheKey);
//       if (cached) {
//         setData(cached.data);
//         setRefetch(true);
//       } else {
//         setLoading(true);
//       }

//       return silentRevalidate({ cacheKey: finalCacheKey, callArgs, ttl })
//         .then((res) => {
//           if (!mounted.current) return res;
//           if (res?.status) {
//             setError(null);
//             setData(res);
//           } else {
//             setError(res);
//           }
//           return res;
//         })
//         .finally(() => {
//           if (!mounted.current) return;
//           setLoading(false);
//           setRefetch(false);
//         });
//     }

//     // PUT / PATCH / DELETE → no cache
//     setLoading(true);
//     return CallAPI(...callArgs)
//       .then((res) => {
//         if (!mounted.current) return res;
//         if (res?.status) {
//           setError(null);
//           setData(res);
//           invalidateByEndpoint(end_point); // important
//         } else {
//           setError(res);
//         }
//         return res;
//       })
//       .finally(() => mounted.current && setLoading(false));
//   };

//   return {
//     data,
//     loading, // no data yet
//     refetch, // background refresh
//     error,
//     revalidate,
//     invalidate: () => deleteCache(cacheKey),
//   };
// }

// useCallAPI.js
import { useEffect, useMemo, useRef, useState } from "react";
import { silentRevalidate } from "../utils/revalidate";
import {
  invalidateByEndpoint,
  buildCacheKey,
  deleteCache,
  getCache,
  isFresh,
} from "../utils/apiCache";
import { CallAPI } from "../utils/apiActions";

export function useCallAPI({
  end_point,
  method = "GET",
  apiUrl,
  body = "",
  isFile,
  showDefaultError = true,
  ttl = 30_000,
  enabled = true,
}) {
  const token = localStorage.getItem("accessToken");
  const METHOD = method.toUpperCase();
  const isCacheable = METHOD === "GET" || METHOD === "POST";

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [error, setError] = useState(null);

  const mounted = useRef(true);
  useEffect(
    () => () => {
      mounted.current = false;
    },
    [],
  );

  const cacheKey = useMemo(
    () =>
      buildCacheKey({
        end_point,
        apiUrl,
        token,
        method: METHOD,
        body,
      }),
    [end_point, apiUrl, token, METHOD, body],
  );

  // AUTO FETCH
  useEffect(() => {
    if (!enabled || !isCacheable) return;

    const callArgs = [
      end_point,
      METHOD,
      apiUrl,
      body,
      isFile,
      showDefaultError,
    ];
    const cached = getCache(cacheKey);

    if (cached && isFresh(cached)) {
      setData(cached.data);
    } else if (cached) {
      setData(cached.data); // stale-while-revalidate
      setRefetch(true);
    } else {
      setLoading(true);
      setRefetch(true);
    }

    silentRevalidate({ cacheKey, callArgs, ttl })
      .then((res) => {
        if (!mounted.current) return;
        if (res && res.status !== false) {
          setError(null);
          setData(res);
        } else {
          setError(res);
        }
      })
      .finally(() => {
        if (!mounted.current) return;
        setLoading(false);
        setRefetch(false);
      });
  }, [cacheKey, enabled, isCacheable]);

  // MANUAL REVALIDATE
  const revalidate = (overrideBody, overrideUrl = null) => {
    const finalBody = overrideBody ?? body;
    const finalUrl = overrideUrl ?? apiUrl;

    const callArgs = [
      end_point,
      METHOD,
      finalUrl,
      finalBody,
      isFile,
      showDefaultError,
    ];

    // console.log(isCacheable, "isCacheable");

    if (isCacheable) {
      const finalCacheKey = buildCacheKey({
        end_point,
        apiUrl: finalUrl,
        token,
        method: METHOD,
        body: finalBody,
      });
      // console.log(finalCacheKey, "finalCacheKey");

      const cached = getCache(finalCacheKey);
      // console.log(cached, "cached=",new Date().toLocaleTimeString());
      if (cached) {
        setData(cached.data);
        setRefetch(true);
      } else {
        setLoading(true);
      }

      return silentRevalidate({ cacheKey: finalCacheKey, callArgs, ttl })
        .then((res) => {
          if (!mounted.current) return res;
          if (res) {
            setError(null);
            setData(res);
          } else {
            setError(res);
          }
          return res;
        })
        .finally(() => {
          if (!mounted.current) return;
          setLoading(false);
          setRefetch(false);
        });
    }

    // PUT/PATCH/DELETE → direct call
    setLoading(true);
    return CallAPI(...callArgs)
      .then((res) => {
        if (!mounted.current) return res;
        if (res) {
          setError(null);
          setData(res);
          // invalidateByEndpoint(end_point);
        } else {
          setError(res);
        }
        return res;
      })
      .finally(() => mounted.current && setLoading(false));
  };

  return {
    data,
    loading,
    refetch,
    error,
    revalidate,
    invalidate: () => deleteCache(cacheKey),
  };
}
